import { formatMYR, formatDate } from "./api";

// CSV cell escape: wrap with quotes if contains comma/quote/newline
function csvCell(v) {
    const s = v == null ? "" : String(v);
    if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
}

function toCsv(rows) {
    return rows.map((r) => r.map(csvCell).join(",")).join("\r\n");
}

function download(filename, content, type = "text/csv;charset=utf-8") {
    // UTF-8 BOM so Excel opens Chinese correctly
    const bom = "\uFEFF";
    const blob = new Blob([bom + content], { type });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}

export function exportProductsCSV(products) {
    const header = ["名称", "SKU", "分类", "供应商", "库存", "低库存阈值", "成本 (RM)", "售价 (RM)", "描述", "创建时间"];
    const rows = [header, ...products.map((p) => [
        p.name, p.sku, p.category || "", p.supplier || "",
        p.stock, p.low_stock_threshold ?? 0,
        p.cost_price, p.unit_price,
        p.description || "", p.created_at || "",
    ])];
    const ts = new Date().toISOString().slice(0, 10);
    download(`products-${ts}.csv`, toCsv(rows));
}

export function exportSalesCSV(sales, mode = "invoice") {
    if (mode === "line") {
        const header = ["发票号", "客户", "日期", "产品", "SKU", "数量", "单价 (RM)", "小计 (RM)", "折扣 (RM)", "折扣 %", "总额 (RM)", "平台", "付款方式", "备注"];
        const rows = [header];
        sales.forEach((s) => {
            s.items.forEach((it, i) => {
                rows.push([
                    i === 0 ? s.invoice_no : "",
                    i === 0 ? s.customer_name : "",
                    i === 0 ? formatDate(s.created_at) : "",
                    it.product_name, it.sku, it.quantity, it.unit_price, it.line_total,
                    i === 0 ? s.discount : "",
                    i === 0 ? (s.discount_percent || 0) : "",
                    i === 0 ? s.total : "",
                    i === 0 ? (s.platform || "") : "",
                    i === 0 ? (s.payment_method || "") : "",
                    i === 0 ? (s.note || "") : "",
                ]);
            });
        });
        const ts = new Date().toISOString().slice(0, 10);
        download(`sales-detail-${ts}.csv`, toCsv(rows));
        return;
    }
    // Invoice summary (one row per sale)
    const header = ["发票号", "客户", "日期", "商品数", "小计 (RM)", "折扣 (RM)", "折扣 %", "总额 (RM)", "平台", "付款方式", "备注"];
    const rows = [header, ...sales.map((s) => [
        s.invoice_no, s.customer_name, formatDate(s.created_at),
        s.items.reduce((n, it) => n + it.quantity, 0),
        s.subtotal, s.discount, s.discount_percent || 0, s.total,
        s.platform || "", s.payment_method || "", s.note || "",
    ])];
    const ts = new Date().toISOString().slice(0, 10);
    download(`sales-summary-${ts}.csv`, toCsv(rows));
}

// TSV: opens directly in Excel as columns when double-clicked
export function exportProductsTSV(products) {
    const csv = toCsv([]); void csv;
    const header = ["名称", "SKU", "分类", "供应商", "库存", "阈值", "成本(RM)", "售价(RM)"];
    const rows = [header, ...products.map((p) => [p.name, p.sku, p.category || "", p.supplier || "", p.stock, p.low_stock_threshold ?? 0, p.cost_price, p.unit_price])];
    const tsv = rows.map((r) => r.map((c) => String(c ?? "").replace(/\t|\n|\r/g, " ")).join("\t")).join("\r\n");
    const ts = new Date().toISOString().slice(0, 10);
    download(`products-${ts}.xls`, tsv, "application/vnd.ms-excel");
}

void formatMYR;
